import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Breadcrumb, Spin, Divider } from 'antd';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components';

import { getId } from '../../utils/params';
import { getDetailPage } from '../../actions';

const FeaturedImage = styled.div`
  overflow: hidden;
  background-size: cover;
  background-position: center;
  height: 220px;
  margin-top: 10px;
  background-color: #364d79;
  background-image: url(${props => props.src});
`;

class Page extends Component {
  componentDidMount() {
    this.getDetail(this.props.match.params.code);
  }

  componentWillReceiveProps(nextProps) {
    const { match: { params: { code } } } = this.props;
    if (nextProps.match.params.code !== code) {
      this.getDetail(nextProps.match.params.code);
    }
  }

  getDetail = code => {
    const id = getId(code);
    this.props.getDetailPage(id);
  }

  render() {
    const { page: { detail, detailLoading }, match } = this.props;

    if (!detail || detailLoading) {
      return <Spin />;
    }

    return (
      <div>
        <Breadcrumb style={{ margin: '5px 0' }}>
          <Breadcrumb.Item><Link to='/'>Trang chủ</Link></Breadcrumb.Item>
          <Breadcrumb.Item><Link to={`/${match.params.code}`}>{detail.title}</Link></Breadcrumb.Item>
        </Breadcrumb>
        {detail.featuredImage && <FeaturedImage src={detail.featuredImage} />}
        <h2 style={{ marginTop: 10 }}>{detail.title}</h2>
        <Divider />
        {ReactHtmlParser(detail.content)}
      </div>
    );
  }
}

export default connect(state => ({
  page: state.page,
}), {
  getDetailPage,
})(Page);



// WEBPACK FOOTER //
// ./src/screens/Page/Page.js